"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailOverlays = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_components_1 = require("@as-react/common-components");
const StickyBarContainer_1 = require("../../../containers/StickyBarContainer");
const ComparePopupAlpha_1 = require("../compare-popup/ComparePopupAlpha");
const ProductDetailTabPopover_1 = require("../product-detail-tab/ProductDetailTabPopover");
const react_1 = require("react");
const ProductDetailOverlays = () => {
    const [isHiddenStickyBar, setHiddenStickyBar] = (0, react_1.useState)(true);
    const { feature_toggles: { show_sticky_bar_pdp }, pageInfo: { isGiftCardPage }, } = (0, common_components_1.useAemConfig)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [show_sticky_bar_pdp && !isGiftCardPage && ((0, jsx_runtime_1.jsx)(StickyBarContainer_1.StickyBarContainer, { isHidden: isHiddenStickyBar, setHidden: setHiddenStickyBar })), (0, jsx_runtime_1.jsx)(ComparePopupAlpha_1.ComparePopupAlpha, { isStickyBar: !isHiddenStickyBar }), (0, jsx_runtime_1.jsx)("div", { id: ProductDetailTabPopover_1.PDP_TABS_PORTAL_NAME })] }));
};
exports.ProductDetailOverlays = ProductDetailOverlays;
